import { BaseService } from '../../core/BaseService';
import {
  GetMarketplaceModulesResponse,
  GetMarketplacePagedResponse,
  MarketplacePagedParams,
  MarketplaceRequestPayload,
  MarketplaceRequestResponse,
} from './interface';

export class MarketplaceProfile extends BaseService {
  async getMarketplaceModules() {
    return this.get<GetMarketplaceModulesResponse>(`${this.apiUrl}/api/marketplace/modules`);
  }

  async getMarketplacePaged(params: MarketplacePagedParams) {
    return this.get<GetMarketplacePagedResponse>(`${this.apiUrl}/api/marketplace/paged`, params);
  }

  async requestMarketplaceModule(req: MarketplaceRequestPayload) {
    return this.post<MarketplaceRequestResponse, MarketplaceRequestPayload>(
      `${this.apiUrl}/api/marketplace`,
      req,
    );
  }
}
